import React, { forwardRef } from 'react';

const AutoSelectInput = forwardRef(({ value, onChange, placeholder, type = "text", ...rest }, ref) => {
    return (
        <input
            ref={ref}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            onFocus={(e) => e.target.select()}
            {...rest}
        />
    );
});

export default AutoSelectInput;
